import { makeStyles, Theme, createStyles, Grid } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            fontFamily: "Open Sans",
            fontSize: "1.07143rem",
            color: "#757575",
            margin: "0",
            // textAlign: 'center'
        },
    })
);


export function CollectionPointHeader() {
    const { t } = useTranslation();
    const { root } = useStyles();

    return <>
        <Grid item xs={4}>
            <p className={root}>{t('forms.orders.pickup.headers.name')}</p>
        </Grid>
        <Grid item xs={3}>
            <p className={root}>{t('forms.orders.pickup.headers.max')}</p>
        </Grid>
        <Grid item xs={1}>
            <p className={root}>{t('forms.orders.pickup.headers.enabled')}</p>
        </Grid>
        <Grid item xs={4}>
        </Grid>
    </>;
}